/* eslint-disable max-lines */
/* eslint-disable consistent-return */
/* eslint-disable react/require-default-props */
/* eslint-disable no-alert, react/jsx-no-bind, react/no-multi-comp*/
import React, {useState} from "react";
import AnalyticsHelper from "../../shared/modules/AnalyticsHelper";
import CartHelper from "../../shared/modules/CartHelper";
import EmptyCart from "../Cart/EmptyCart";
import LoadingSpinner from "../BuyItNow/components/LoadingSpinner";
import NonMemberAddressInfo from "./NonMemberAddressInfo";
import NonMemberBillingInfo from "./NonMemberBillingInfo";
import NonMemberCartAPI from "../../shared/modules/NonMemberCartAPI";
import NonMemberCartHeader from "./NonMemberCartHeader";
import NonMemberCartItemCard from "./NonMemberCartItemCard";
import NonMemberPromoCodeField from "./NonMemberPromoCodeField";
import NonMemberSummary from "./NonMemberSummary";
import PropTypes from "prop-types";
import ReCaptcha from "../CondensedSignupFlow/components/ReCaptcha";
import {withCookies} from "react-cookie";

const NonMemberCart = ({
  addressInfo,
  billingInfo,
  captchaToken,
  cartInfo,
  cartTotals,
  cookies,
  handleCloseCartModal,
  handleDisplayPurchaseNotification,
  loadingPage,
  promos,
  promoCode,
  recaptchaSiteKey,
  refreshCart,
  setCaptchaToken,
  setCartInfo,
  setCartTotals,
  setNotificationText,
  setIsEditingBilling,
  setIsEditingAddress,
  setPromoCode,
  setPromos,
  setShowStripeCheckout,
  stripeEnabled
}) => {
  if (loadingPage) return (
    <div className="Cart">
      <NonMemberCartHeader
        classes="justify-between items-center text-2xl"
        handleCloseCartModal={handleCloseCartModal}
        showCloseButton
      />
      loading your shopping cart...
    </div>
  );

  const [
    loadingPurchase,
    setLoadingPurchase
  ] = useState(false);

  const hasValidAddressInfo = () => CartHelper.hasValidAddressInfo(addressInfo);
  const hasBillingInfo = () => CartHelper.hasBillingInfo(billingInfo);

  const handleCheckout = () => {
    if (!hasValidAddressInfo()) {
      setNotificationText("Please enter shipping information");
      return;
    }
    // eslint-disable-next-line no-undef
    setCaptchaToken(grecaptcha.getResponse());
    setShowStripeCheckout(true);
  };

  const clearCart = () => {
    cookies.remove("non_member_cart", {"path": "/"});
    cookies.remove("auto_applied_promo_code", {"path": "/"});
  };

  const handlePurchaseSuccess = (response) => {
    AnalyticsHelper.sendPurchasedCartEvent(response.invoice, response.orders);
    handleDisplayPurchaseNotification();
    clearCart();
    refreshCart();
  };

  const handlePurchase = () => {
    if (!hasValidAddressInfo()) {
      setNotificationText("Please enter shipping information");
      return;
    }
    if (!hasBillingInfo()) {
      setNotificationText("Please enter billing information");
      return;
    }
    setLoadingPurchase(true);

    const token = billingInfo.recurlyToken;
    const contactId = addressInfo.id;

    // eslint-disable-next-line no-undef
    const captcha = grecaptcha.getResponse();
    NonMemberCartAPI.purchaseCart(token, contactId, captcha, promoCode).then((response) => {
      if (response.error) {
        CartHelper.handlePurchaseError(response, setNotificationText);
        setLoadingPurchase(false);
      } else {
        handlePurchaseSuccess(response);
        handleCloseCartModal();
      }
    });
  };

  const handleEditAddressInfo = () => {
    setIsEditingAddress(true);
  };
  const handleEditBillingInfo = () => {
    setIsEditingBilling(true);
  };

  const getCartItemCount = () => {
    if (!cartInfo) return "";

    const {"retail_items": retailItems, "clearance_items": clearanceItems} = cartInfo;
    let count = 0;

    retailItems.forEach((item) => {
      count += item.quantity;
    });

    clearanceItems.forEach((item) => {
      count += item.quantity;
    });

    return count;
  };

  const mapCartItems = (items, storeKind) => items.map(item => (
    <NonMemberCartItemCard
      id={`${item.product_descriptor.id}`}
      itemInfo={item}
      key={`${item.product_descriptor.id}`}
      refreshCart={refreshCart}
      setCartInfo={setCartInfo}
      setNotificationText={setNotificationText}
      storeKind={storeKind}
    />
  ));

  const getButtonText = () => {
    if (stripeEnabled) {
      return hasValidAddressInfo() ? "Proceed to Checkout" : "Enter Shipping & Contact Info";
    }
    if (!hasValidAddressInfo()) {
      return "Enter Shipping & Contact Info";
    } else if (!hasBillingInfo()) {
      return "Enter Billing Info";
    }
    return "Place Order";
  };

  const handleButtonClick = () => {
    if (stripeEnabled) {
      if (!hasValidAddressInfo()) {
        handleEditAddressInfo();
        return;
      }
      return handleCheckout();
    }
    if (!hasValidAddressInfo()) {
      handleEditAddressInfo();
      return;
    }
    if (!hasBillingInfo()) {
      handleEditBillingInfo(true);
      return;
    }
    return handlePurchase();
  };

  const renderStripeCartInfo = () => {
    const retailItemCards = mapCartItems(cartInfo.retail_items, "retail");
    const clearanceItemCards = mapCartItems(cartInfo.clearance_items, "clearance");

    return (
      <div className="cart-info">
        {retailItemCards}
        {clearanceItemCards}
        <NonMemberAddressInfo
          addressInfo={addressInfo}
          setIsEditingAddress={setIsEditingAddress}
        />
        <NonMemberSummary
          cartTotals={cartTotals}
          promos={promos}
        />
        <NonMemberPromoCodeField
          promoCode={promoCode}
          setCartInfo={setCartInfo}
          setCartTotals={setCartTotals}
          setPromoCode={setPromoCode}
          setPromos={setPromos}
        />
        <div className="cart-block flex flex-col gap-4">
          {hasValidAddressInfo() &&
          <ReCaptcha
            recaptchaSiteKey={recaptchaSiteKey}
          />}
          <div className="flex flex-col gap-2">
            {!captchaToken && hasValidAddressInfo() &&
              <div className="rounded-md bg-rose-50 text-rose-600 p-4 text-center">
                Please confirm you are a human (and not a bot) to continue
              </div>
            }
            <button
              className="button-primary"
              onClick={handleButtonClick}
              type="button"
            >
              {getButtonText()}
            </button>
            <button
              className="button-outlined-white"
              onClick={handleCloseCartModal}
              type="button"
            >
              Keep Shopping
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderCartInfo = () => {
    const retailItemCards = mapCartItems(cartInfo.retail_items, "retail");
    const clearanceItemCards = mapCartItems(cartInfo.clearance_items, "clearance");

    return (
      <div className="cart-info">
        {retailItemCards}
        {clearanceItemCards}
        <NonMemberAddressInfo
          addressInfo={addressInfo}
          setIsEditingAddress={setIsEditingAddress}
        />
        <NonMemberBillingInfo
          billingInfo={billingInfo}
          setIsEditingBilling={setIsEditingBilling}
        />
        <NonMemberSummary
          cartTotals={cartTotals}
          promos={promos}
        />
        <NonMemberPromoCodeField
          promoCode={promoCode}
          setCartInfo={setCartInfo}
          setCartTotals={setCartTotals}
          setPromoCode={setPromoCode}
          setPromos={setPromos}
        />
        <div className="cart-block flex flex-col gap-4">
          <ReCaptcha
            recaptchaSiteKey={recaptchaSiteKey}
          />
        </div>
        <div className="flex flex-col gap-2">
          <button
            className="btn btn-primary cart-save-button"
            disabled={loadingPurchase}
            onClick={handleButtonClick}
            type="button"
          >
            {loadingPurchase ? <LoadingSpinner size={26} /> : getButtonText()}
          </button>
          <a
            className="button-outlined-white"
            href="/jewelry"
          >
            Keep Shopping
          </a>
        </div>
      </div>
    );
  };

  const renderCart = () => stripeEnabled ? renderStripeCartInfo() : renderCartInfo();

  const renderEmptyCart = () => (
    <EmptyCart handleCloseCartModal={handleCloseCartModal} />
  );

  return (
    <div className="Cart">
      <NonMemberCartHeader
        classes="justify-between items-center text-2xl"
        handleCloseCartModal={handleCloseCartModal}
        itemCount={getCartItemCount()}
        showCloseButton
      />
      {cartInfo ? renderCart() : renderEmptyCart()}
    </div>
  );
};

NonMemberCart.propTypes = {
  "addressInfo": PropTypes.object,
  "billingInfo": PropTypes.object,
  "captchaToken": PropTypes.string,
  "cartInfo": PropTypes.object,
  "cartTotals": PropTypes.object,
  "cookies": PropTypes.object.isRequired,
  "handleCloseCartModal": PropTypes.func.isRequired,
  "handleDisplayPurchaseNotification": PropTypes.func.isRequired,
  "loadingPage": PropTypes.bool.isRequired,
  "promoCode": PropTypes.string,
  "promos": PropTypes.array,
  "recaptchaSiteKey": PropTypes.string.isRequired,
  "refreshCart": PropTypes.func.isRequired,
  "setCaptchaToken": PropTypes.func.isRequired,
  "setCartInfo": PropTypes.func.isRequired,
  "setCartTotals": PropTypes.func.isRequired,
  "setIsEditingAddress": PropTypes.func.isRequired,
  "setIsEditingBilling": PropTypes.func.isRequired,
  "setNotificationText": PropTypes.func.isRequired,
  "setPromoCode": PropTypes.func.isRequired,
  "setPromos": PropTypes.func.isRequired,
  "setShowStripeCheckout": PropTypes.func.isRequired,
  "stripeEnabled": PropTypes.bool.isRequired
};

NonMemberCart.defaultProps = {
  "addressInfo": null,
  "billingInfo": null,
  "captchaToken": null,
  "cartInfo": null,
  "cartTotals": {},
  "promoCode": null,
  "promos": []
};

export default withCookies(NonMemberCart);
